import {PageLink} from '../../../../_metronic/layout/core'

export const ComplianceMeetingBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const AddBoardMeetingBreadCrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Compliance Meeting',
    path: 'compliance-meeting?tab=upcoming_meeting',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const ComplianceMeetingDetailsBreadCrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Compliance Meeting',
    path: 'compliance-meeting?tab=upcoming_meeting',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const reminderOptions = [
  {
    id: 1,
    name: '30 Days Before',
    value: '30 Days Before',
  },
  {
    id: 2,
    name: '15 Days Before',
    value: '15 Days Before',
  },
  {
    id: 3,
    name: '1 Week Before',
    value: '1 Week Before',
  },
  {
    id: 4,
    name: '3 Days Before',
    value: '3 Days Before',
  },
  {
    id: 5,
    name: '1 Day before',
    value: '1 Day Before',
  },
  {
    id: 6,
    name: 'No Reminder',
    value: 'No Reminder',
  },
]

export const reminderBeforeMeetingOptions = [
  {
    id: 1,
    name: '1 Hour Before Meeting',
    value: '1 Hour Before',
  },
  {
    id: 2,
    name: '30 Minutes Before Meeting',
    value: '30 Min Before',
  },
  {
    id: 3,
    name: '15 Minutes Before Meeting',
    value: '15 Min Before',
  },
  {
    id: 4,
    name: '10 Minutes Before Meeting',
    value: '10 Min Before',
  },
  {
    id: 5,
    name: '5 Minutes Before Meeting',
    value: '5 Min Before',
  },
  {
    id: 6,
    name: 'No Reminder',
    value: 'No Reminder',
  },
]

export const MinutesToAssigned = [
  {
    id: '5 Minutes',
    name: '5 Minutes',
    value: '5 Minutes',
  },
  {
    id: '10 Minutes',
    name: '10 Minutes',
    value: '10 Minutes',
  },
  {
    id: '15 Minutes',
    name: '15 Minutes',
    value: '15 Minutes',
  },
  {
    id: '20 Minutes',
    name: '20 Minutes',
    value: '20 Minutes',
  },
  {
    id: '25 Minutes',
    name: '25 Minutes',
    value: '25 Minutes',
  },
  {
    id: '30 Minutes',
    name: '30 Minutes',
    value: '30 Minutes',
  },
  {
    id: '35 Minutes',
    name: '35 Minutes',
    value: '35 Minutes',
  },
  {
    id: '40 Minutes',
    name: '40 Minutes',
    value: '40 Minutes',
  },
  {
    id: '45 Minutes',
    name: '45 Minutes',
    value: '45 Minutes',
  },
  {
    id: '50 Minutes',
    name: '50 Minutes',
    value: '50 Minutes',
  },
  {
    id: '55 Minutes',
    name: '55 Minutes',
    value: '55 Minutes',
  },
  {
    id: '60 Minutes',
    name: '60 Minutes',
    value: '60 Minutes',
  },
]

export const participantType = [
  {
    id: 1,
    name: 'Co-Host',
    value: 'Co-host',
  },
  {
    id: 2,
    name: 'Host',
    value: 'Host',
  },
  {
    id: 3,
    name: 'Observer',
    value: 'Observer',
  },
  {
    id: 4,
    name: 'Organizer',
    value: 'Organizer',
  },
  {
    id: 5,
    name: 'Participant',
    value: 'Participant',
  },
  {
    id: 6,
    name: 'Others',
    value: 'Others',
  },
]

export const MeetingType = [
  {
    id: 'board_meeting',
    name: 'Board Meetings',
    value: 'board_meeting',
  },
  {
    id: 'shareholders_meeting',
    name: 'Shareholder Meetings',
    value: 'shareholders_meeting',
  },
  {
    id: 'other_meeting',
    name: 'Other Meetings',
    value: 'other_meeting',
  },
]

export const AttendanceType = [
  {
    id: 'unknown',
    name: 'Draft',
    value: 'unknown',
  },
  {
    id: 'invited',
    name: 'Invited',
    value: 'invited',
  },
  {
    id: 'present',
    name: 'Present',
    value: 'present',
  },
  {
    id: 'absent',
    name: 'Absent',
    value: 'absent',
  },
  {
    id: 'accept',
    name: 'Accept',
    value: 'accept',
  },
  {
    id: 'reject',
    name: 'Reject',
    value: 'reject',
  },
]
